import { useT } from '@kmgestao/i18n';
import { PageContainer, PageIntroCard, PageSectionCard } from '@kmgestao/ui';

import { ClinicShell } from '../ClinicShell.js';

/**
 * Tela exibida quando a clínica do owner está em
 * `subscriptions.status='canceled'` ou `'paused'` — clínica encerrada
 * ou em pausa administrativa.
 *
 * Sem botão "recarregar" aqui: estado terminal por design. Owner
 * precisa contatar Karla pra reativar (PR futura: fluxo de reativação
 * automatizado quando faz sentido).
 */
export function SuspendedPage() {
  const { t } = useT('clinics');

  return (
    <ClinicShell>
      <PageContainer>
        <PageIntroCard
          eyebrow="🔒"
          title={t('suspended.title')}
          description={t('suspended.description')}
        />

        <PageSectionCard
          title={t('suspended.contact.title')}
          description={t('suspended.contact.description')}
        >
          <p className="text-sm text-muted-foreground">{t('suspended.contact.body')}</p>
        </PageSectionCard>
      </PageContainer>
    </ClinicShell>
  );
}
